import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { LoadingService } from './loading.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { UserBoxComponent } from './user-box/user-box.component';
import { MenuComponent } from './menu/menu.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { NotificationService } from './notification.service';
import { SharedModule } from '../shared/shared.module';
import { OutLayoutComponent } from "./out-layout/out-layout.component";
import { PlusButtonComponent } from './plus-button/plus-button.component';
import { PageContainerComponent } from './page-container/page-container.component';

const COMPONENTS: Array<any> = [
    LayoutComponent,
    HeaderComponent,
    BreadcrumbsComponent,
    UserBoxComponent,
    MenuComponent,
    MenuItemComponent,
    OutLayoutComponent
];

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        RouterModule,
        SharedModule
    ],
    declarations: [
        ...COMPONENTS,
        PlusButtonComponent,
        PageContainerComponent,
    ],
    providers: [
        LoadingService,
        NotificationService
    ],
  exports: [
    ...COMPONENTS,
    PlusButtonComponent,
    PageContainerComponent
  ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class LayoutModule {
}
